export class Microsoft365BackupScope {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userIds",
            "baseName": "userIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sharepointSiteIds",
            "baseName": "sharepointSiteIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "teamIds",
            "baseName": "teamIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "hasPolicy",
            "baseName": "hasPolicy",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365BackupScope.attributeTypeMap;
    }
    constructor() {
    }
}
